import React from "react";

export const ServicePositionTableFoot = ({ data }) => {
    return (
        <tfoot>
            <tr>
                <td colSpan={4}>
                    <small>
                        {data.total} {data.total === 1 ? "Service" : "Services"}
                    </small>
                </td>
            </tr>
        </tfoot>
    );
};

export default ServicePositionTableFoot;
